import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'No Excuses',
  date: new Date(2023, 8, 24),
  img: '/img/jazz-vampire.jpeg',
  tracks: [
    {
      title: 'A New Beginning',
      src: '/songs/2023-09-24/a_new_beginning.mp3',
    },
    {
      title: 'Main Street, Germany',
      src: '/songs/2023-09-24/main_street_germany.mp3',
    },
    {
      title: 'A Walk around The Room',
      src: '/songs/2023-09-24/a_walk_around_the_room.mp3',
    },
    {
      title: 'Speaking a Universal Language',
      src: '/songs/2023-09-24/speaking_a_universal_language.mp3',
    },
    {
      title: 'Staying Dry in a Downpour',
      src: '/songs/2023-09-24/staying_dry_in_a_downpour.mp3',
    },
    {
      title: 'The Minion Song',
      src: '/songs/2023-09-24/the_minion_song.mp3',
    },
    {
      title: 'Empty Mic Stand',
      src: '/songs/2023-09-24/empty_mic_stand.mp3',
    },
    {
      title: 'Jazzy Vampires in Paris',
      src: '/songs/2023-09-24/jazzy_vampires_in_paris.mp3',
    },
    {
      title: 'Imposter Syndrome',
      src: '/songs/2023-09-24/imposter_syndrome.mp3',
    },
    {
      title: 'That\'s so True',
      src: '/songs/2023-09-24/thats_so_true.mp3',
    },
    {
      title: 'I\'ll wait for You',
      src: '/songs/2023-09-24/ill_wait_for_you.mp3',
    },
    {
      title: 'Lay down by The Water',
      src: '/songs/2023-09-24/lay_down_by_the_water.mp3',
    },
    {
      title: 'Speaking in Tongues',
      src: '/songs/2023-09-24/speaking_in_tongues.mp3',
    },
    {
      title: 'Speak to Me in My Dreams',
      src: '/songs/2023-09-24/speak_to_me_in_my_dreams.mp3',
    },
    {
      title: 'Off the Rails (Doghouse Casey)',
      src: '/songs/2023-09-24/off_the_rails_doghouse_casey.mp3',
    },
  ]
}
export default album;